"use strict";
/**
 * @module Serialisers
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../io/codec");
/**
 * A Serialiser for string values
 */
var StringSerialiserClass = /** @class */ (function () {
    function StringSerialiserClass() {
    }
    /**
     * @inheritdoc
     */
    StringSerialiserClass.prototype.read = function (bis) {
        return Codec.readString(bis);
    };
    /**
     * @inheritdoc
     */
    StringSerialiserClass.prototype.write = function (bos, val) {
        Codec.writeString(bos, val);
    };
    return StringSerialiserClass;
}());
exports.StringSerialiserClass = StringSerialiserClass;
/**
 * The {@link StringSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.StringSerialiser = new StringSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/serialisers/string-serialiser.js
// module id = 145
// module chunks = 1